import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AppState } from "../../../../../../stateManager/store";
import { getValue, getComponents } from "../../helpers";
import { data } from "../data";
import { Dropdown } from "./helpers/constants";

import { onChange } from "./helpers/on-change"
import { FormCreationData } from "../../../../../../stateManager/store/formCreation_v2/types";

const DEFAULT_FONT_WEIGHT: string = "properties.styles.common.fontWeight";
const DEFAULT_FONT_WEIGHT_V3: string = "properties.styles.$deviceType.fontWeight";

type Props = {
  label: string;
  isCheckedIn: boolean;
  defaultValue?: string;
}

const excluded_types = [
  "ExpansionPanel",
  "Row",
  "Column",
  "Divider",
  "Grid",
  "Modal",
  "CustomModal"
]

export const FontWeight = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, isCoreV3, computedStyles, wrapperComputedStyles } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue, label } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useState(defaultValue);
  const component: FormCreationData = components[selectedElementId];
  const { type } = component;

  useEffect(() => {
    if (isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_FONT_WEIGHT_V3.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      }
      else {
        const wrapperStyles = wrapperComputedStyles.hasOwnProperty("fontWeight") ? wrapperComputedStyles : computedStyles;
        const fontWeight = (wrapperStyles && wrapperStyles.fontWeight && wrapperStyles.fontWeight.match(/\d+/) ? wrapperStyles.fontWeight.match(/\d+/)[0] : null);
        setValue(fontWeight)
        setOldValue(fontWeight)
      }
    }else if (!isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_FONT_WEIGHT.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      }
    }
    // eslint-disable-next-line
  }, [isCoreV3, component, deviceType, computedStyles]);

  if (isCoreV3 && excluded_types.includes(type)) {
    return null;
  }

  return (
    <div className="panel-div">
      <label
        htmlFor="FontWeight"
        className="panel-label"
      >
        {label}
      </label>
      <Dropdown
        cursorStyle={!isCheckedIn ? "not-allowed" : "auto"}
        disabled={!isCheckedIn}
        options={
          data.fontWeight
            ? data.fontWeight.map((el) => ({
              name: el.label,
            }))
            : []
        }
        selected={{ name: value as string }}
        onChange={(option) => {
          if (data.fontWeight) {
            const item = data.fontWeight.find(item => item.label === option.name)
            if (item) {
              const value = item.value
              setValue(value)
              onChange({
                path: isCoreV3 ? DEFAULT_FONT_WEIGHT_V3 : DEFAULT_FONT_WEIGHT,
                value,
                oldValue,
                setOldValue,
                selectedElementId
              })
            }
          }
        }}
      />
    </div>
  )
};
